import { FeatureCard } from 'sections/Company/CodeOfEthics/types';

export const featureCardsData: FeatureCard[] = [
  {
    id: 1,
    iconName: 'icon-star',
    description: 'We take personal pride in what we do.',
  },
  {
    id: 2,
    iconName: 'icon-calendar',
    description: 'Our members voluntarily attend conferences and events organized by the Alliance.',
  },
  {
    id: 3,
    iconName: 'icon-file',
    description: 'We’re committed to complying with all international rules and regulations.',
  },
  {
    id: 4,
    iconName: 'icon-network',
    description: 'We provide the greatest possible support for the running programs offered by the network.',
  },
  {
    id: 5,
    iconName: 'icon-phone',
    description: 'We’re committed to replying to all sales leads within 12 hours.',
  },
  {
    id: 6,
    iconName: 'icon-person',
    description: 'We’re committed to providing bona fide sales leads.',
  },
  {
    id: 7,
    iconName: 'icon-people',
    description: "We’re committed to working closely together in a friendly family atmosphere respecting each other's culture, religion, and political situation.",
  },
  {
    id: 8,
    iconName: 'icon-question',
    description: 'Alliance members are committed to responding to all shipping requests within 12 hours.',
  },
  {
    id: 9,
    iconName: 'icon-coins',
    description: 'Our members are committed to paying their membership fees and any other dues linked to Alliance programs or conferences in a timely manner and no later than 30 days after the invoice date.',
  },
  {
    id: 10,
    iconName: 'icon-handshake',
    description: 'We support other members of the Alliance as much as possible, and DF Alliance members are committed to contributing to the goals of the network.',
  },
];